/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetCompanyBusinessPartnerIdResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        properties: {
          businessPartnerId: {
            type: 'string',
            isRequired: true,
          },
        },
        isRequired: true,
      },
    },
  }],
} as const;
